import { TableCellType } from "@/constants/table/table"
import { UserTableRow } from "@/types/users"
import { ColumnDef } from "@tanstack/react-table"

export const columns: ColumnDef<UserTableRow>[] = [
  {
    accessorKey: "name",
    header: "Name",
    meta: { type: TableCellType.LINK_BUTTON },
  },
  {
    accessorKey: "email",
    header: "Email Address",
    meta: { type: TableCellType.TEXT },
  },
  {
    accessorKey: "role",
    header: "Role",
    meta: { type: TableCellType.TEXT },
  },
  {
    accessorKey: "action",
    header: "Actions",
    meta: { type: TableCellType.ACTIONS },
  },
]
